<!--
Important:
This Component is used only for the Vue3 application
Any modifications made should be done for Vue2 component also
Vue2File: wwwroot\js\WebsitePrimary\components\VehicleCount\VehicleCountContainer\VehicleCountContainer.vue
Vue3 JS File: wwwroot\js\WebsitePrimary\components\VehicleCount\VehicleCountContainer\VehicleCountContainer.js
Dont forget to make the changes in both the files
Any clarifications contact Laxman
-->
<template>
  <div>
    <div>
      <component
        :heading="heading"
        :sub-heading="subHeading"
        :hide-pricing="hidePricing"
        :enable-vehicle-count="enableVehicleCount"
        :inventory-count-label="inventoryCountLabel"
        :inventory-sort="inventorySort"
        :is="componentName"
        v-if="componentName"
        @vehiclecount="onVehicleCountGot"
        :vdp-navigation="vdpNavigation"
        :filter-models="filterModels"
        :vehicle-type="vehicleType"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";

import PrimaryVehicleCount from "../../VehicleCount/VehicleCount.vue";
import LuxuryVehicleCount from "../../VehicleCount/LuxuryVehicleCount.vue";
import FrameVehicleCount from "../../VehicleCount/FrameVehicleCount.vue";
import BmwVehicleCount from "../../VehicleCount/BmwVehicleCount.vue";
import MitsubishiOemVehicleCount from "../../VehicleCount/MitsubishiOemVehicleCount.vue";
import ParagonPrimaryVehicleCount from "../../VehicleCount/ParagonPrimaryVehicleCount.vue";
import { useLazyLoadComponent } from "../../../Composables/LazyLoadComponent/useLazyLoadComponent";
import { LayoutConstants } from "../../../../../js/constants/LayoutConstants";

const props = defineProps({
  heading: { default: "" },
  subHeading: { default: "" },
  enableVehicleCount: { default: "" },
  hidePricing: { type: Boolean, default: false },
  inventoryCountLabel: { default: "" },
  designType: { default: "" },
  inventorySort: { default: "" },
  filterModels: { type: Array, default: () => [] },
  vdpNavigation: { default: false },
  vehicleType: { default: "" },
});

const emit = defineEmits(["vehiclecount"]);

const componentName = ref("");
const { lazyLoadComponent } = useLazyLoadComponent();

const loadVehicleComponents = () => {
  if (props.designType === "1") {
    componentName.value = "MitsubishiOemVehicleCount";
    return;
  }
  if (props.designType === "2") {
    componentName.value = "FrameVehicleCount";
    return;
  }
  if (props.designType === "3") {
    componentName.value = "PrimaryVehicleCount";
    return;
  }

  switch (window.masterLayoutName.toLowerCase()) {
    case LayoutConstants.WEBSITE_FRAME:
      componentName.value = "FrameVehicleCount";
      break;
    case LayoutConstants.WEBSITE_LUXURY:
    case LayoutConstants.WEBSITE_LUXURY_PORSCHE:
      componentName.value = "LuxuryVehicleCount";
      break;
    case LayoutConstants.WEBSITE_BMW:
      componentName.value = "BmwVehicleCount";
      break;
    case LayoutConstants.WEBSITE_PARAGON_PRIMARY:
      componentName.value = "ParagonPrimaryVehicleCount";
      break;
    default:
      componentName.value = "PrimaryVehicleCount";
      break;
  }
};

const onVehicleCountGot = (count) => {
  emit("vehiclecount", count);
};

if (!window.isVdp) {
  loadVehicleComponents();
}

watch(lazyLoadComponent, (newVal) => {
  if (newVal && window.isVdp) {
    loadVehicleComponents();
  }
});
</script>
<script>
export default {
  components: {
    PrimaryVehicleCount,
    LuxuryVehicleCount,
    FrameVehicleCount,
    BmwVehicleCount,
    MitsubishiOemVehicleCount,
    ParagonPrimaryVehicleCount,
  },
};
</script>
